import { User } from "../../schema/types/user/entity";
import { linksOf } from "../../services/cpln";
import { parseLink } from "../../utils/linkParser/linkParser";

export interface UserTableItem extends User {
  selfLink: string;
}

interface GetUserTableItemProps {
  link?: string;
  name?: string;
  email?: string;
  item?: User;
}
export function getUserTableItem({ link, name, email, item }: GetUserTableItemProps): UserTableItem {
  if (item) {
    const selfLink = linksOf(item).self!;

    return {
      ...item,
      selfLink: selfLink,
    };
  }

  if (link) {
    const { name } = parseLink(link, { useInputCtx: true });

    return {
      kind: "user",
      email: email || name,
      name: name,
      selfLink: link,
      links: [{ rel: "self", href: link }],
      created: "",
      description: "",
      id: "",
      lastModified: "",
      tags: {},
      version: 1,
    };
  }

  // assume name
  return {
    kind: "user",
    email: email || name!,
    name: name!,
    selfLink: `TODO test if this breaks`,
    links: [],
    created: "",
    description: "",
    id: "",
    lastModified: "",
    tags: {},
    version: 1,
  };
}
